export default "__VITE_ASSET__BbQTWQS4__"